import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1504">
      <Hero data-id="element-1505" />
      <LocalTrust data-id="element-1506" />
      <Services data-id="element-1507" />
      <HowItWorks data-id="element-1508" />
      <FAQ data-id="element-1509" />
      <Reviews data-id="element-1510" />
    </main>;
}